import {
  Assignment,
  AssignmentStatus,
  CurriculumAssignmentContent,
  DesmosAssignment,
  SingleAssignment,
} from 'src/interfaces/assignment.types';
import {
  ASSIGNMENT_STUDENT_HOME_SECTION,
  AssignmentCommonXApiContextPayload,
  MS_ASSIGNMENT_STATUSES,
} from 'src/interfaces/event.types';

export const getDoneAssignments = (
  assignments?: Assignment[],
): Assignment[] => {
  if (!assignments) return [];
  return assignments.filter(
    (assignment): assignment is SingleAssignment | DesmosAssignment =>
      'status' in assignment && assignment.status === AssignmentStatus.READ,
  );
};

type XApiAssignmentDataProps = {
  assignmentBusinessKey?: string;
  assignmentClassBk?: string | Array<string>;
  classGrade: string;
  content: CurriculumAssignmentContent;
  assignmentStatus?: ASSIGNMENT_STUDENT_HOME_SECTION | MS_ASSIGNMENT_STATUSES;
  isAssignmentMarkedDone?: boolean | null;
  cardstackBusinessKey?: string;
};

export const generateAssignmentDataForEventPayload = ({
  assignmentBusinessKey,
  assignmentClassBk,
  classGrade,
  content,
  assignmentStatus,
  isAssignmentMarkedDone,
  cardstackBusinessKey,
}: XApiAssignmentDataProps): AssignmentCommonXApiContextPayload => {
  return {
    assignmentBusinessKey,
    assignmentClassBk,
    assignmentMarkedDone: isAssignmentMarkedDone,
    assignmentStatus,
    cardstackBusinessKey,
    classGrade,
    customContentId:
      'customContentId' in content && content.customContentId
        ? content.customContentId
        : undefined,
    domain: 'domain' in content ? content.domain : undefined,
    isCustom:
      'brand' in content &&
      (content.brand === 'custom' || content.brand === 'customized'),
    lessonBusinessKey: 'lessonKey' in content ? content.lessonKey : undefined,
    unitBusinessKey: 'unitKey' in content ? content.unitKey : undefined,
    unitRevisionNumber:
      'unitRevision' in content ? Number(content.unitRevision) : undefined,
    unitRevisionAlias:
      'unitRevisionAlias' in content ? content.unitRevisionAlias : undefined,
  };
};
